/**
 * Countries Tax Ops can pick when creating a bank connection. GoCardless lists
 * each bank under exactly one country (e.g. Holvi only under Finland), so the
 * bank list is requested per country. To offer another country, add its
 * (uppercase) code here and a label under `createConnectionForm.country.options`
 * in both i18n files.
 */
export const INSTITUTION_COUNTRIES = ["DE", "FI"] as const;

export type InstitutionCountry = (typeof INSTITUTION_COUNTRIES)[number];

export const DEFAULT_INSTITUTION_COUNTRY: InstitutionCountry = "DE";
